// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AmUFqqjRHDafuA {\n  background-color: transparent;\n  border: none;\n  box-shadow: none;\n  color: var(--ds-icon, #42526e);\n  padding: 0;\n  text-decoration: none;\n}\n.AmUFqqjRHDafuA:active,\n.AmUFqqjRHDafuA:hover {\n  background-color: transparent;\n  border: none;\n  box-shadow: none;\n  color: var(--ds-icon-accent-gray, #172b4d);\n  cursor: pointer;\n  outline: 0;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"closeButton": "AmUFqqjRHDafuA"
};
export default ___CSS_LOADER_EXPORT___;
